import APIClient from '../factories/APIClient'

import attachMock from '../factories/attachMock'
import MOCK_RESPONSES from './EFoodChoices.mock.json'

const client = new APIClient({
  baseURL: process.env.REACT_APP_EXPLORE_API_BASE_URL,
})

if (process.env.NODE_ENV === 'development') {
  attachMock(
    client,
    MOCK_RESPONSES,
  )({
    // 'get /merchants': 200,
    // 'get /merchants*': 422,
    // 'get /stores/details': 200,
    // 'get /stores/*': 200,
    // 'get /stores': 200,
    // 'get /search': 200,
    // 'get /display/shop*': 200,
    // 'get /display/dine*': 422,
    // 'get /display/unwind*': 422,
    // 'get /display/featured?type=0*': 200,
    // 'get /display/featured?type=1*': 200,
    // 'get /display/featured?type=2*': 200,
    // 'get /participating-stores': 200
    // 'get /events/*/arcticles': 200,
    // 'get /popup-modals': 200,
  })
}

const cacheControl = { 'Cache-Control': 'max-age=0' }

export const getAllBrands = accessToken => {}

export const getAllRestaurants = (mallSlugName, accessToken) =>
  client({
    method: 'get',
    url: `/efood-choices?mallSlugName=${encodeURIComponent(mallSlugName)}`,
    headers: cacheControl,
  })

export const getAllMalls = () => {}

export const getAllNearbyRestaurants = (mallSlugName, accessToken) => {}

export const searchMallMerchants = ({ mallSlugName, brandName }, accessToken) =>
  client({
    method: 'get',
    url: `/efood-choices`,
    params: {
      mallSlugName,
      brandName,
    },
    headers: cacheControl,
  })
